import React, {useEffect, useState} from 'react';
import {
    Switch,
    Route, withRouter, Redirect
} from "react-router-dom";
import RouteGuard from "./RouteGuard";
import loadable from '../utils/loadable';

const Login = loadable(() => import('../components/common/Login'));
const Login2 = loadable(() => import('../components/common/Login2'));
const AppContainer = loadable(() => import('../container/AppContainer'));
const UserProtocol = loadable(() => import('../components/common/UserProtocol'));
const NBLargeScreen = loadable(() => import('../components/projects/energy_centralized/components/mainPage/Index'));
const ZXLargeScreen = loadable(() => import('../container/NoLoginContainer2'));
const FXLargeScreen = loadable(() => import('../container/NoLoginFeixiContainer'));//肥西供电所大屏
const GQLargeScreen = loadable(() => import('../container/NoLoginGuquanContainer'));//古泉供电所大屏
const JHLargeScreen = loadable(() => import('../components/projects/power-grid/dashboard/components/jinhua/Index'));//金华市综大屏
const RealTimeData = loadable(() => import('../container/NoLoginHzzxContainer'));
const wzlogin = loadable(() => import('../container/NoLoginContainer'));
const ShangHaiDashboard = loadable(() => import('../container/NoLoginContainerShangHai'));
const MRoute = (props) => {
    useEffect(() => {
        document.getElementById("loading").style.display = "none";
    }, [])

    return  <Switch>
                <Route exact path={"/protocol"} component={UserProtocol}/>
                <Route exact path={"/login"} component={Login}/>
                <Route exact path={"/app/energy_centralized/mainpage"} component={NBLargeScreen}/>
                <Route exact path={"/app/pastoral/complex/dashboard"} component={ZXLargeScreen}/>
                <Route exact path={"/app/peach_garden/complex/dashboard"} component={FXLargeScreen}/>
                <Route exact path={"/app/jinhua/complex/dashboard"} component={JHLargeScreen}/>
                <Route exact path={"/app/guquan/complex/dashboard"} component={GQLargeScreen}/>
                <Route exact path={"/app/smart_energy/energy_mgt/energy_monitor"} component={RealTimeData}/>
                <Route exact path={"/wz_nologin"} component={wzlogin}/>
                <Route exact path={"/xqc_login"} component={Login2}/>
                <Route exact path={"/app/large-screen-pv"} component={ShangHaiDashboard}/>
                <Route  path="/app">
                    <RouteGuard>
                        <AppContainer/>
                    </RouteGuard>
                </Route>
                <Redirect to="/login"/>
        </Switch>
}

export default withRouter(MRoute);
